<template>
    <div class="faq-wrap" :class="getCurThemeType=='enWrap' ? 'enWrap-font-wrap':''">
      <div class="page1-wrap page-same">
        <div class="title1">{{$t('faq.title')}}</div>
        <!-- <div class="title2">{{$t('products.navTitle13')}}</div> -->
      </div>
      <div class="page2-wrap page-same">
					<div class="title">{{$t('faq.title2')}}</div>
          <div class="w">
						<header class="header">
							<p v-html="$t('faq.title3')"></p>
						</header>
						<div class="list-wrap">
							<div class="list-item" v-for="(item,index) in pageList" :key="index">
								<div class="lable">
									<img src="../../assets/img/faq/lable.png" alt="">
									<p class="lable">{{$t('faq.' + item.label)}}</p>
								</div>
								<p class="item">{{$t('faq.' + item.value)}}</p>
							</div>
						</div>
          </div>
      </div>
    </div>
</template>

<script>

    export default {
        name: "services",
        metaInfo: {
            title: 'KrngPartners', // set a title
            meta: [{             // set meta
                name: '',
                content: ''
            },
            {
                name: '',
                content: ''
            }]
        },
        data() {
            return {
							pageList:[
								{label:'label1',value:'textItem1'},
								{label:'label2',value:'textItem2'},
								{label:'label3',value:'textItem3'},
								{label:'label4',value:'textItem4'},
								{label:'label5',value:'textItem5'},
								{label:'label6',value:'textItem6'},
								{label:'label7',value:'textItem7'},
								{label:'label8',value:'textItem8'},
								{label:'label9',value:'textItem9'},
								{label:'label10',value:'textItem10'},
								{label:'label11',value:'textItem11'},
								{label:'label12',value:'textItem12'},
								{label:'label13',value:'textItem13'},
								{label:'label14',value:'textItem14'},
								{label:'label15',value:'textItem15'},
								{label:'label16',value:'textItem16'},
								{label:'label17',value:'textItem17'},
							]
            }
        },
        computed: {


        },
        components: {

        },
        created(){

        },

        methods: {
        },
        mounted() {

        },
    }
</script>

<style lang="scss" scoped>
    @import "faq.scss";
</style>
